import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {createApiResponseParser} from "../../api/api-response-parser.util";
import {TeamParams, TeamResponseSchema} from "./team.schema";

@Injectable({ providedIn: 'root' })

export class TeamApi {
  readonly #http = inject(HttpClient);
  readonly #baseUrl = environment.url;

  getTeam() {
    return this.#http
      .get(`${this.#baseUrl}/teams`, {
        params: {...TeamParams},
      })
      .pipe(map(createApiResponseParser(TeamResponseSchema)));
  }
}
